// extracted by mini-css-extract-plugin
export default {"overlay":"MenuDrawer_overlay__Yv7++","menu":"MenuDrawer_menu__ASHbz","show":"MenuDrawer_show__XDvoc","fadeIn":"MenuDrawer_fadeIn__84yyC","content":"MenuDrawer_content__pL-p5"};